<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.99475 8.00024C1.99475 11.3115 4.68868 14.0055 7.99997 14.0055C9.53492 14.0055 10.9372 13.4266 12 12.4757V12.0001L12.3979 12.0853C13.3948 11.0128 14.0052 9.57647 14.0052 8.00021C14.0052 4.68891 11.3113 1.99487 7.99997 1.99487C4.68868 1.99487 1.99475 4.68894 1.99475 8.00024Z" class="icon-fill"/>
    <path d="M13.0912 2.90886C11.7313 1.54899 9.92317 0.800049 7.99999 0.800049C6.0768 0.800049 4.26873 1.54899 2.9088 2.90886C1.54893 4.26879 0.799988 6.07686 0.799988 8.00005C0.799988 9.92324 1.54893 11.7313 2.9088 13.0912C4.26873 14.4511 6.0768 15.2 7.99999 15.2C9.92317 15.2 11.7313 14.4511 13.0912 13.0912C14.451 11.7313 15.2 9.92324 15.2 8.00005C15.2 6.07686 14.451 4.26879 13.0912 2.90886ZM12.7929 12.7929C11.5126 14.0731 9.81051 14.7782 7.99999 14.7782C6.18947 14.7782 4.48734 14.0731 3.20712 12.7929C1.9269 11.5127 1.22186 9.81057 1.22186 8.00005C1.22186 6.18953 1.9269 4.48741 3.20712 3.20718C4.48734 1.92696 6.18947 1.22192 7.99999 1.22192C9.81051 1.22192 11.5126 1.92696 12.7929 3.20718C14.0731 4.48741 14.7781 6.18953 14.7781 8.00005C14.7781 9.81057 14.0731 11.5127 12.7929 12.7929Z" class="icon-fill"/>
  </svg>


</template>

<script>
export default {
  name: 'oem'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>